import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/funny', label: '分类' },
    { to: '/articles', label: '资讯' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-play-fill text-background-50 text-lg"></i>
            </div>
            <span
              className={`text-xl font-bold font-heading whitespace-nowrap ${
                isScrolled || !isHome ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              快猫短视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  location.pathname === link.to
                    ? isScrolled || !isHome
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-background-50/20 text-background-50'
                    : isScrolled || !isHome
                      ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                      : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="px-5 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              下载 App
            </button>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label={isMobileMenuOpen ? '关闭菜单' : '打开菜单'}
          >
            <i
              className={`text-xl ${
                isScrolled || !isHome ? 'text-foreground-950' : 'text-background-50'
              } ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            ></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden pb-4 bg-background-50 rounded-b-2xl shadow-lg mx-[-16px] px-4">
            <div className="flex flex-col gap-1 pt-2">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                    location.pathname === link.to
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <button className="mt-2 w-full px-5 py-3 text-sm font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                下载 App
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}